/**
 * useTouchDevice Hook
 * Detects if the device has touch capability
 */
import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect if the device has touch capability
 * Uses media query approach for reliability on modern devices
 * Checks (pointer: coarse) which is the most accurate indicator
 *
 * @returns boolean indicating if device supports touch
 *
 * @example
 * const isTouch = useTouchDevice();
 * if (isTouch) {
 *   // Show touch-optimized UI
 * }
 */
export function useTouchDevice(): boolean {
  // (pointer: coarse) and (hover: none) is the most reliable way to detect touch-only devices
  // This will match phones and tablets, but not devices with both touch and mouse capability
  const isTouchOnly = useMediaQuery('(pointer: coarse) and (hover: none)');

  // Return true only for touch-only devices (phones/tablets)
  // This allows hover to work on hybrid devices (Windows with touchscreen but primarily mouse-driven)
  return isTouchOnly;
}
